import React, { useState } from 'react';
import {
  FDAccordionGroup,
  FDSimpleAccordion,
} from '@facet-wealth/design';
import PropTypes from 'prop-types';
import { inputDefaultProps, inputPropTypes } from 'Packages/FacetDesign/Components/propTypes';
import { useDataAttrs } from 'Helpers/Testing';
import { Richtext } from '../Richtext';

export const Accordion = ({
  label, value, richtext, ...rest
}) => {
  const [expanded, setExpanded] = useState(false);
  return (
    <FDAccordionGroup variant="separated">
      <FDSimpleAccordion
        {...useDataAttrs(rest)}
        expanded={expanded}
        onChange={setExpanded}
        title={label}
      >
        <Richtext value={value} richtext={richtext} />
      </FDSimpleAccordion>
    </FDAccordionGroup>
  );
};


Accordion.defaultProps = {
  label: inputDefaultProps.label,
};
Accordion.propTypes = {
  label: inputPropTypes.label,
  value: PropTypes.string.isRequired,
};
